// ENTITYS
export const MOBILE_APPLICATION_ENTITY = 'Service';
export const MOBILE_VERSION_ENTITY = 'ServiceInstance';

/**
 *
 * Enum for browser enity values for browser monitoring capability.
 * @readonly
 * @enum {string}
 */
export enum MOBILE_ENTIY {
  /** @member {string} */
  MOBILE_APPLICATION_ENTITY = 'Service',
  /** @member {string} */
  MOBILE_VERSION_ENTITY = 'ServiceInstance',

  /** @member {string} */
  MOBILE_OS_ENTITY = 'OS'
}

/**
 *
 * Enum for NAVTAB values for browser monitoring capability.
 * @readonly
 * @enum {string}
 */
export enum NAVTABS {
  /** @member {string} */
  MOBILE_KPI_USAGE_TAB = 'Usage',
  
  /** @member {string} */
  MOBILE_KPIS_CRASHES_TAB = 'Crashes',

  /** @member {string} */
  MOBILE_KPIS_PERFORMANCE_TAB = 'Performance'
}
